import { createAction, props } from '@ngrx/store';
import {
  MicrositeSessionsState,
  Tokens,
  SafeUserData,
} from './coreAuth.models';
import { HttpErrorState } from '../shared/error.models';

export const callMicrositeSessions = createAction(
  '[Auth] Login Microsite',
  // Optional id to match the response back to this call. Custom creator so old bare calls still work.
  (requestId?: string) => ({ requestId }),
);

export const successMicrositeSessions = createAction(
  '[Auth] Microsite Session Success',
  props<{
    response?: MicrositeSessionsState;
    // TODO: Verify with backend team - this may contain user preferences, wallet data
    optionalData?: SafeUserData;
    requestId?: string;
  }>(),
);

export const setOptionalData = createAction(
  '[Auth] Microsite Set Optional Data',
  props<{
    optionalData?: SafeUserData;
  }>(),
);

export const setCustomMultiplier = createAction(
  '[Auth] Microsite Set Custom Currency Multiplier',
  props<{
    curr_mult?: number;
  }>(),
);

export const callMicrositeRefreshTokens = createAction(
  '[Auth] Refresh Tokens Microsite',
);

export const successMicrositeRefreshTokens = createAction(
  '[Auth] Microsite Refresh Token Success',
  props<{
    response: Tokens;
  }>(),
);

export const setMicrositeAuthTokenAuthorizationCode = createAction(
  '[Auth] Microsite Set Authorization code',
  props<{
    authorization_code: string;
  }>(),
);

export const failMicrositeSessions = createAction(
  '[Auth] Microsite Session Fail',
  props<{
    error: HttpErrorState;
    requestId?: string;
  }>(),
);

export const triggerSignIn = createAction('[Auth] Microsite Trigger Sign In');

// The user abandoned a sign-in: closed the login modal without a session, or the biometric
// attempt ended without one. Whatever was waiting on that login (e.g. a deep link) should give up.
export const loginCancelled = createAction('[Auth] Login Cancelled');

export const triggerRegistration = createAction(
  '[Auth] Microsite Trigger registration',
);

export const clearSession = createAction('[Auth] Clear Session - user logout');
